import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { Store } from '@ngxs/store';
import { combineLatest, distinctUntilChanged, filter, map, Observable } from 'rxjs';
import { GrdfAccessRightModel } from '../../grdf.models';
import { GrdfState } from '../../grdf.state';

interface TabsItem {
    display: string;
    routerLink: any[];
    routerLinkActiveOptions?: any;
}

@UntilDestroy()
@Component({
    selector: 'app-grdf-meter',
    templateUrl: './grdf-meter.component.html',
    styleUrls: ['./grdf-meter.component.scss'],
})
export class GrdfMeterComponent {
    title = '';
    subTitle = '';

    public grdfAccessRight$: Observable<GrdfAccessRightModel> = inject(Store)
        .select(GrdfState.currentAccessRight)
        .pipe(filter(Boolean));
    public currentAccessRightId = '';

    public tabItems: TabsItem[] = [
        {
            display: 'Données générales',
            routerLink: [`./informations`],
            routerLinkActiveOptions: { exact: false },
        },
        {
            display: 'Consommations',
            routerLink: [`./consumption`],
            routerLinkActiveOptions: { exact: false },
        },
    ];

    constructor(
        private readonly route: ActivatedRoute,
        private readonly sidenavService: SidenavService,
        private readonly store: Store,
    ) {
        this.grdfAccessRight$.pipe(untilDestroyed(this)).subscribe((grdfAccessRight) => {
            this.currentAccessRightId = grdfAccessRight.id;
            this.subTitle = `PRM n° ${grdfAccessRight.pdlNumber}`;
            if (grdfAccessRight.clientName) {
                this.title = `${grdfAccessRight.clientName}`;
            } else {
                this.title = `${grdfAccessRight.clientRepresentativeName}`;
            }
        });
    }
}
